import React from "react"
import DateButtonsRow from "./DateButtonsRow"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import moment from "moment"
import * as timecardHelper from "../../helpers/timecardHelper"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import { ITimecardDates, IDate, IPayrollPayCalendar, IPayrollPayGroupData } from "../../models"
import _ from "lodash"
import * as payrollHelper from "../../helpers/payrollHelper"

interface IProps {
    referenceDate: IDate
    // should set payrollSettings (payrollPayGroupData, payGroupId or payCalendar)
    payrollPayGroupData?: IPayrollPayGroupData
    payGroupId?: string
    payCalendar?: IPayrollPayCalendar

    handleChangeReferenceDate(date: IDate, timecardDates: ITimecardDates): void
}
interface IState {
    referenceDate: IDate
    timecardDates?: ITimecardDates
}

//use browser local time
export default class TimecardDateRange extends React.Component<IProps, IState>  {
    constructor(props: IProps) {
        super(props)
        this.state = {
            referenceDate: this.getReferenceDateWithStartTime(props.referenceDate, props.payrollPayGroupData, props.payGroupId, props.payCalendar),
            timecardDates:
                props.payCalendar ?
                    timecardHelper.getTimecardDateByPayrollPayCalendar(props.referenceDate, props.payCalendar) :
                    props.payGroupId ?
                        timecardHelper.getTimecardDateByPayGroupId(props.referenceDate, props.payGroupId) :
                        timecardHelper.getTimecardDateByPayrollPayGroupData(props.referenceDate, props.payrollPayGroupData)
        }
        autobind(this)
    }

    componentWillReceiveProps(nextProps: IProps) {
        if (this.props.referenceDate !== nextProps.referenceDate) {
            this.setState({ referenceDate: this.getReferenceDateWithStartTime(nextProps.referenceDate, nextProps.payrollPayGroupData, nextProps.payGroupId, nextProps.payCalendar) })
        }

        ((this.props.payrollPayGroupData && !_.isEqual(this.props.payrollPayGroupData, nextProps.payrollPayGroupData)) ||
            this.props.payGroupId !== nextProps.payGroupId ||
            (this.props.payCalendar && !_.isEqual(this.props.payCalendar, nextProps.payCalendar))
        ) &&
            this.handleChangeReferenceDate(this.state.referenceDate, nextProps.payrollPayGroupData, nextProps.payGroupId, nextProps.payCalendar)

    }

    handleChangeReferenceDate(date: IDate, payrollPayGroupData: IPayrollPayGroupData, payGroupId: string, payCalendar: IPayrollPayCalendar) {
        const referenceDate = this.getReferenceDateWithStartTime(date, payrollPayGroupData, payGroupId, payCalendar)
        this.setState({
            referenceDate,
            timecardDates:
                payCalendar ?
                    timecardHelper.getTimecardDateByPayrollPayCalendar(referenceDate, payCalendar) :
                    payGroupId ?
                        timecardHelper.getTimecardDateByPayGroupId(referenceDate, payGroupId) :
                        timecardHelper.getTimecardDateByPayrollPayGroupData(referenceDate, payrollPayGroupData)
        }, () =>
            this.props.handleChangeReferenceDate(this.state.referenceDate, this.state.timecardDates)
        )
    }

    getReferenceDateWithStartTime(date: IDate, payrollPayGroupData: IPayrollPayGroupData, payGroupId: string, payCalendar: IPayrollPayCalendar): IDate {
        const startTime24Hours = payCalendar ?
            payCalendar.PayPeriodDayStartTime24Hour :
            payGroupId ?
                payGroupAndTypeHelper.getPayGroupById(payGroupId).PaySettings.PayPeriodDayStartTime24Hour :
                payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData(payrollPayGroupData).PaySettings.PayPeriodDayStartTime24Hour
        return moment(date).startOf("day").add(startTime24Hours, "hours")
    }

    render() {
        const payGroup =
            this.props.payCalendar ?
                payrollHelper.getPayGroupsByPayrollPayCalendar(this.props.payCalendar)[0] :
                this.props.payGroupId ?
                    payGroupAndTypeHelper.getPayGroupById(this.props.payGroupId) :
                    payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData(this.props.payrollPayGroupData)
        return (
            <div style={{ display: "flex" }}>
                <div style={{ marginTop: "25px" }}>
                    <i
                        data-intercom-target={"Timecards-Btn-View-Previous-TimeCard"}
                        className="fa fa-arrow-circle-left"
                        title={strings.View_previous_timecard}
                        onClick={() => this.handleChangeReferenceDate(moment(this.state.referenceDate).add(-1, "week"), this.props.payrollPayGroupData, this.props.payGroupId, this.props.payCalendar)}
                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                    />
                    <span style={{ fontSize: 15, marginLeft: 5, marginRight: 5 }}>
                        {moment(this.state.timecardDates.StartDate).format("ddd MMM. DD, YYYY")} &mdash; {moment(this.state.timecardDates.EndDate).format("ddd MMM. DD, YYYY")}
                    </span>
                    <i
                        data-intercom-target={"Timecards-Btn-View-Next-TimeCard"}
                        className="fa fa-arrow-circle-right"
                        title={strings.View_next_timecard}
                        onClick={() => this.handleChangeReferenceDate(moment(this.state.referenceDate).add(1, "week"), this.props.payrollPayGroupData, this.props.payGroupId, this.props.payCalendar)}
                        style={{ color: "#aaaaaa", cursor: "pointer" }}
                    />
                </div>
                <DateButtonsRow
                    startDay={payGroup.PaySettings.PayPeriodStartDay}
                    referenceDate={moment(this.state.referenceDate).toDate()}
                    getThisWeek={() => this.handleChangeReferenceDate(moment(), this.props.payrollPayGroupData, this.props.payGroupId, this.props.payCalendar)}
                    getLastWeek={() => this.handleChangeReferenceDate(moment().add(-1, "week"), this.props.payrollPayGroupData, this.props.payGroupId, this.props.payCalendar)}
                    handleChangeReferenceDate={referenceDate => this.handleChangeReferenceDate(referenceDate, this.props.payrollPayGroupData, this.props.payGroupId, this.props.payCalendar)}
                />
            </div>
        )
    }
}
